import styled from '@emotion/styled';

import { FieldElementProps } from './types';

export const FieldElement = styled.div<FieldElementProps>`
  font-family: ${({ theme }) => theme.general.font_family};
  font-size: ${({ theme }) => theme.general.font_size};
  border-radius: ${({ theme }) => theme.general.border_radius};
  background: ${({ theme }) => theme.background.normal};
  border: ${({ theme }) => theme.border.normal};
  color: ${({ theme }) => theme.color.normal};

  input::placeholder {
    color: ${({ theme }) => theme.general.placeholder};
  }

  &:hover {
    background: ${({ theme }) => theme.background.hover};
    border: ${({ theme }) => theme.border.hover};
    color: ${({ theme }) => theme.color.normal};
  }

  /* transparent state */
  &[data-transparent='true'] {
    background: transparent;
    border: 1px solid transparent;
    border-radius: 0px;
  }

  /* focus state */
  ${({ is_focused, theme }) =>
    is_focused &&
    `
     background: ${theme.background.focus};
     border: ${theme.border.focus};
     color: ${theme.color.normal};
   `}

  /* active state */
 &:active {
    background: ${({ theme }) => theme.background.active};
    border: ${({ theme }) => theme.border.active};
    color: ${({ theme }) => theme.color.normal};
  }

  /* disabled state */
  &[data-disabled='true'] {
    background: ${({ theme }) => theme.background.disabled};
    border: ${({ theme }) => theme.border.disabled};
    color: ${({ theme }) => theme.color.disabled};
    pointer-events: none;
    opacity: 0.6;
  }

  /* error state */
  &[data-error='true'] {
    background: ${({ theme }) => theme.background.error};
    border: ${({ theme }) => theme.border.error};
    color: ${({ theme }) => theme.color.error};
  }

  /* autofill background */
  input {
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px ${({ theme }) => theme.background.normal} inset !important;
      -webkit-text-fill-color: ${({ theme }) => theme.color.normal} !important;
    }

    /* firefox */
    &:autofill {
      background: ${({ theme }) => theme.background.normal} !important;
      color: ${({ theme }) => theme.color.normal} !important;
    }
  }
`;
